module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/february/mainvisual-title-sp-buyback_fbe326caa1df2c92789a8cd17d1a3315.png";